module.exports = __webpack_public_path__ + "static/shape16-7b165020ad7482a0feacec9e9c7f7bf5.png";